<template>
  <div>
    <div class="logo" style="text-align: center;">
      <!-- <a href="#" class="simple-text logo-mini">
        
      </a> -->
      <router-link class="logo-normal" :to="{ path: '/' }" style="color: white!important;font-size: 17pt!important;">
        <!-- <template v-if="$route.meta.rtlActive" -->
          <!-- ><b>{{ rtlTitle }}</b> -->
          <!-- </template -->
        <!-- > -->
        <!-- <template v-else -->
          <!-- ><b>{{ title }}</b></template> -->
      <!-- <img :src="backgroundImage" alt=""> -->
      </router-link>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list> 
    </div>
    <hr>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "SellerPeak24"
    },
    rtlTitle: {
      type: String,
      default: "SellerPeak24"
    },
    activeColor: {
      type: String,
      default: "green",
      validator: value => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
          "grey"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: `${process.env.VUE_APP_BASE_URL}/img/favicon.png`
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    // logo: {
    //   type: String,
    //   default: `${process.env.VUE_APP_BASE_URL}/img/vue-logo.png`
    // },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.$sidebar.toggleMinimize();
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },

  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
